<template>
  <div>
    <Loading :loading="loading" />

    <v-alert v-if="!loading && !categories.length" type="info" text>
      {{ $t('organization.noCategories') }}
    </v-alert>

    <v-row
      v-for="(cat, i) in categories"
      :key="i"
    >
      <v-col>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              {{ cat.title }}
            </v-toolbar-title>
            <v-spacer />
            <small>
              {{ cat.persons.length }}
            </small>
          </v-toolbar>
          <v-card-text class="text-body-2">
            <v-data-table
              :headers="headers"
              :items="cat.persons"
              :items-per-page="-1"
              hide-default-footer
              sort-by="sortOrder"
              dense
            >
              <template #[`item.cellPhone`]="{ item }">
                {{ item.cellPhone ? item.cellPhone : item.phone | phoneNumber }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import OrganizationRoleCategoryComponent from '@/components/OrganizationRoleCategoryComponent.vue';

export default {  
  name: 'Organization',
  components: {
    Loading,
    OrganizationRoleCategoryComponent
  },
  data() {
    return {
      categories: [],
      loading: true,
      headers: [
        { text: this.$t('common.name'), value: 'fullName', width: '25%' },
        { text: this.$t('common.title'), value: 'title', width: '20%' },
        { text: this.$t('common.role'), value: 'roleTitle', width: '25%' },
        { text: this.$t('common.phone'), value: 'cellPhone', width: 200 },
        { text: this.$t('common.email'), value: 'email', width: '20%' }
      ]
    }
  },
  mounted: async function() {
    // this.getCategories();

    this.loading = true;

    try {
      const response = await this.$api.get('organizations/overview');
      this.categories = response.data?.data?.categories;
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    // getCategories: async function() {
    //   this.loading = true;
      
    //   try {
    //     const { data } = await this.$api.get('role-categories', {
    //       params: {
    //         customerId: this.$store.state.primaryCustomerId,
    //         organizational: true
    //       }
    //     });

    //     this.rawCategories = data;
    //   } catch (error) {
    //     this.$notifier.showError({});
    //     console.error(error)
    //   } finally {
    //     this.loading = false;
    //   }
    // }
  }
}
</script>